//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: { // 接受父组件传递的值
    liveTab: {
      type: Array, default: () => []
    },
    liveLangInfo: {
      type: Array, default: () => []
    }
  },
  data () {
    return {
      liveTabcode: 0, // tabcode
      swLang: this.liveLangInfo[0].livelanguageshow, // 切换语言
      langState: false // 语言下拉框
    }
  },
  created () {

  },
  beforeDestroy () {
    document.removeEventListener('click', this.langClose)
  },
  mounted () {
    console.log('liveLangInfo', this.liveLangInfo)
    document.addEventListener('click', this.langClose)
  },
  methods: {
    langClose (e) { // 点击非组件区域关闭下拉框
      if (!this.$el.contains(e.target)) this.langState = false
    },
    tabSwitch (i) { // tab栏状态切换
      this.liveTabcode = i // 赋值切换样式
      this.$emit('getListswitch', i) // 列表数据切换
    },
    switchLang (i) { // 语言切换
      this.swLang = i.livelanguageshow
      this.$emit('getListLang', i.livelanguage)
    }
  }
}
